import { Link } from "react-router-dom";

const Answer = ({ data }) => {
  return (
    <Link
      className="btn-answer"
      to={{ pathname: `/form/${data._id}`, state: data }}
    >
      Répondre
    </Link>
  );
};
export default Answer;
